import { __assign } from "tslib";
import { getFormDataWithParams } from '../../base/utils';
import { EDIT_NOTIFY, NOTIFY_SCOPE, } from './cgi-path';
import { networkRequest } from '@tencent/ark-request';
var NotifyScopeRepository = /** @class */ (function () {
    function NotifyScopeRepository() {
    }
    NotifyScopeRepository.prototype.getNotifyType = function (params) {
        var formData = getFormDataWithParams(__assign({}, params));
        return networkRequest.post(NOTIFY_SCOPE, formData);
    };
    NotifyScopeRepository.prototype.setNotifyType = function (params) {
        var formData = getFormDataWithParams(__assign({}, params));
        return networkRequest.post(NOTIFY_SCOPE, formData);
    };
    NotifyScopeRepository.prototype.editnotify = function (params) {
        var formData = getFormDataWithParams(__assign({}, params));
        return networkRequest.post(EDIT_NOTIFY, formData);
    };
    return NotifyScopeRepository;
}());
export { NotifyScopeRepository };
